export default __webpack_public_path__ + "static/media/quizloading_background1.73969f05.jpg";